import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html } from "lit";
import { rif } from "../../../helpers/renderIf.js";
import "../../atom/Icon/index.js";
import { getButtonStyles, getIconClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfStepNumber = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "medium";
  }
  render() {
    const buttonStyles = getButtonStyles(this);
    const iconClasses = getIconClasses(this);
    return html`
      <button
        tabindex="-1"
        dsf_size="small"
        class=${buttonStyles}
        dsf_level=${!this.dsf_state ? "secondary" : "primary"}
      >
        ${this.dsf_state === "completed" ? html`<dsf-icon dsf_name="Check" class=${iconClasses}></dsf-icon>` : rif(this.dsf_size !== "minimal", html`<slot></slot>`)}
      </button>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfStepNumber.prototype, "dsf_state", 2);
__decorateClass([
  prop({ type: String })
], DsfStepNumber.prototype, "dsf_size", 2);
DsfStepNumber = __decorateClass([
  defineElement("dsf-step-number")
], DsfStepNumber);
export {
  DsfStepNumber
};
